import * as tslib_1 from "tslib";
import { PlaylistPlayerComponentBase } from '@app/player/playlist-player.component.base';
var PlaylistPlayerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PlaylistPlayerComponent, _super);
    function PlaylistPlayerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlaylistPlayerComponent;
}(PlaylistPlayerComponentBase));
export { PlaylistPlayerComponent };
